import { render } from "./ChatBox.vue?vue&type=template&id=67f8fe2c&scoped=true"
import script from "./ChatBox.vue?vue&type=script&lang=js"
export * from "./ChatBox.vue?vue&type=script&lang=js"

import "./ChatBox.vue?vue&type=style&index=0&id=67f8fe2c&lang=scss&scoped=true"

import exportComponent from "D:\\Front-end\\vuechat\\app-ua-truth-chat\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67f8fe2c"]])

export default __exports__